export default __webpack_public_path__ + "static/media/background.f6b59471.png";